import { render, staticRenderFns } from "./cuotomer.vue?vue&type=template&id=e8e8e93c&scoped=true&"
import script from "./cuotomer.vue?vue&type=script&lang=js&"
export * from "./cuotomer.vue?vue&type=script&lang=js&"
import style0 from "./cuotomer.vue?vue&type=style&index=0&id=e8e8e93c&lang=scss&scoped=true&"
import style1 from "./cuotomer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e8e93c",
  null
  
)

export default component.exports